
import React from 'react';

interface AsteroidsInstructionsProps {
  isMobile: boolean;
}

const AsteroidsInstructions: React.FC<AsteroidsInstructionsProps> = ({ isMobile }) => {
  return (
    <div 
      className={`absolute ${isMobile ? 'top-2 left-2' : 'top-14 left-4'} 
                  text-white bg-black bg-opacity-50 p-2 rounded-lg 
                  ${isMobile ? 'text-xs' : 'text-sm'}`}
      aria-label="Game Instructions"
      role="region"
      tabIndex={0}
    >
      {!isMobile ? (
        <>
          <p>Arrow keys to move</p>
          <p>Space to shoot</p>
          <p>Breathe deeply and focus</p>
        </>
      ) : (
        <>
          <p>Use touch controls below</p>
          <p>Breathe deeply and focus</p>
        </>
      )}
    </div>
  );
};

export default AsteroidsInstructions;
